import React from 'react';
import COMPARISON_DATA from '../utils/ComparisonData';
import { Link, useNavigate } from "react-router-dom";

export default function OnThisPage({ classes }) {
  const navigate = useNavigate();

  const handleChange = (e) => {
    const selectedSlug = e.target.value; // Get the selected slug
    if (selectedSlug) {
      navigate(`/comparison/${selectedSlug}`); // Navigate to the URL with the selected slug
    }
  };

  return (
    <div className='px-2'>
      <select
        className={`mb-[10px] w-full bg-[#F2EBFA] font-[600] px-[10px] py-[5px] ${classes}`}
        onChange={handleChange}
        defaultValue=""
      >
        <option value="" className='font-[600]' disabled>On this page</option>
        {COMPARISON_DATA.comparisons.map((comparison) => (
          <option className='font-[600]' key={comparison.id} value={comparison.slug}>
            <Link to={`/comparison/${comparison.slug}`}>
              {comparison.services}
            </Link>
            {/* {comparison.services} Display the comparison title */}
          </option>
        ))}
      </select>
    </div>
  );
}